module.exports = __webpack_public_path__ + "media/images/aboutus/SAPC5456-b48233c3202f779b7c9e0fae9d05def1.jpg";